export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
};

export const calculateTenureMonthlyPrice = (basePrice, tenure) => {
  const normalizedBasePrice = Number(basePrice) || 0;
  const normalizedTenure = Number(tenure) || 6;

  if (normalizedTenure >= 24) return Math.round(normalizedBasePrice * 0.95);
  if (normalizedTenure >= 12) return Math.round(normalizedBasePrice);
  if (normalizedTenure >= 9) return Math.round(normalizedBasePrice * 1.05);
  return Math.round(normalizedBasePrice * 1.1);
};

export const calculateDeposit = (price, depositPercentage = 3) => {
  // Security deposit = 3x monthly rent (fallback when explicit product deposit is not provided)
  return Math.round(price * depositPercentage);
};

export const resolveSecurityDeposit = (item = {}, fallbackPrice = 0, depositPercentage = 3) => {
  const explicitDeposit = Number(item?.securityDeposit || 0);
  if (Number.isFinite(explicitDeposit) && explicitDeposit > 0) {
    return Math.round(explicitDeposit);
  }

  const price = Number(fallbackPrice || item?.price || 0);
  return calculateDeposit(price, depositPercentage);
};

export const calculateMonthlyTotal = (items) => {
  return items.reduce((total, item) => total + (item.price * item.quantity), 0);
};

export const calculateTotalDeposit = (items, depositPercentage = 3) => {
  return items.reduce((total, item) => {
    const itemDeposit = resolveSecurityDeposit(item, item.price, depositPercentage);
    return total + (itemDeposit * item.quantity);
  }, 0);
};

export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const generateId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};
